/* 19MW1016: eigen basis uit live, 2026-09-22. Zie het configuratorproject en _START-HIER.md.
*/
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-ss-configurator="19mw1016"]');
  if (!root) return;

  // voorkomt dubbel initialiseren
  if (root.dataset.ss19mw1016UploaderBound === '1') return;
  root.dataset.ss19mw1016UploaderBound = '1';

  const readJson = (selector) => {
    const el = root.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '');
    } catch (e) {
      return null;
    }
  };

  // Icons uit DOM JSON (nieuw), fallback naar oude window global (mag, maar hoeft niet meer)
  const ICONS =
    readJson('[data-ss-uploader-assets]') ||
    window.SS_UPLOADER_ASSETS ||
    {};

  const CHECK_ICON_URL = ICONS.check || '';
  const TRASH_ICON_URL = ICONS.trash || '';

  // Config uit DOM JSON (nieuw), fallback naar oude window global
  const CFG =
    readJson('[data-ss-uploader-config]') ||
    window.SS_UPLOADER_CONFIG ||
    {};

  const UPLOAD_URL =
    CFG.uploadUrl || 'https://api.track-net.nl/shopify-uploader/upload-from-shopify';

  // >>> HIERONDER jouw bestaande code laten staan <<<
  const fileInput   = root.querySelector('.design__file');
  const hiddenIds   = root.querySelector('#uploaded_image_ids');
  const hiddenLabel = root.querySelector('#uploaded_image_label');
  const form        = root.querySelector('form');
  const dropZone    = root.querySelector('.configure-wrapper__design');
  if (!fileInput || !hiddenIds || !hiddenLabel || !form || !dropZone) return;

  const MAX_SIZE    = 50 * 1024 * 1024;
  const ALLOWED_EXT = ['jpg','jpeg','png','gif','webp','pdf','eps','ai','heic','heif','svg'];
  const MAX_FILES   = 5;

  let uploadsInFlight = 0;
  const uploadedFiles = [];

  const statusEl = document.createElement('div');
  statusEl.className = 'upload-status';
  statusEl.style.marginTop = '0.5rem';
  statusEl.style.fontSize = '0.9rem';
  statusEl.style.color = '#444';

  const errorEl = document.createElement('div');
  errorEl.className = 'upload-error';
  errorEl.style.marginTop = '0.25rem';
  errorEl.style.fontSize = '0.9rem';
  errorEl.style.color = 'red';

  dropZone.appendChild(statusEl);
  dropZone.appendChild(errorEl);

  function setError(msg) { errorEl.textContent = msg || ''; }
  function clearError() { errorEl.textContent = ''; }

  function renderStatus() {
    statusEl.innerHTML = '';
    const total = uploadedFiles.length;
    if (!total) return;

    uploadedFiles.forEach((f, idx) => {
      const wrapper = document.createElement('div');
      wrapper.style.marginBottom = '0.5rem';

      // Titel-regel + groen vinkje (tekst EXACT houden)
      const titleRow = document.createElement('div');
      titleRow.style.display = 'flex';
      titleRow.style.alignItems = 'center';
      titleRow.style.gap = '0.5rem';

      const titleText = document.createElement('span');
      if (total === 1) titleText.textContent = 'Bestand opgeslagen:';
      else titleText.textContent = `Bestand ${idx + 1} opgeslagen:`;

      titleRow.appendChild(titleText);

      //  Vinkje (SVG)
      if (CHECK_ICON_URL) {
        const okImg = document.createElement('img');
        okImg.src = CHECK_ICON_URL;
        okImg.alt = '';
        okImg.width = 22;
        okImg.height = 22;
        okImg.style.display = 'block';
        titleRow.appendChild(okImg);
      } else {
        const okIcon = document.createElement('span');
        okIcon.textContent = '✓';
        okIcon.style.color = '#1aa24a';
        okIcon.style.fontSize = '1.2rem';
        okIcon.style.lineHeight = '1';
        titleRow.appendChild(okIcon);
      }

      // Tweede regel: bullet + naam + prullenbak
      const line = document.createElement('div');
      line.style.display = 'flex';
      line.style.alignItems = 'center';
      line.style.gap = '0.5rem';
      line.style.width = '100%'; // <-- FIX: houd alles binnen de rij

      const bullet = document.createElement('span');
      bullet.textContent = '•';

      const nameSpan = document.createElement('span');
      nameSpan.textContent = f.name;

      // ===== FIX: lange bestandsnamen afkappen i.p.v. prullenbak wegduwen =====
      nameSpan.style.flex = '1 1 auto';
      nameSpan.style.minWidth = '0';           // <-- SUPER belangrijk in flex
      nameSpan.style.overflow = 'hidden';
      nameSpan.style.textOverflow = 'ellipsis';
      nameSpan.style.whiteSpace = 'nowrap';
      // =======================================================================

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.title = 'Dit bestand verwijderen';
      removeBtn.setAttribute('aria-label', 'Dit bestand verwijderen');
      removeBtn.style.border = 'none';
      removeBtn.style.background = 'transparent';
      removeBtn.style.cursor = 'pointer';
      removeBtn.style.padding = '4px 0';
      removeBtn.style.marginLeft = 'auto';
      removeBtn.style.display = 'inline-flex';
      removeBtn.style.alignItems = 'center';
      removeBtn.style.flex = '0 0 auto';
      removeBtn.style.color = '#6b7280';
      removeBtn.style.fontSize = '14px';
      removeBtn.style.lineHeight = '1.2';
      removeBtn.style.textDecoration = 'none';

      const removeText = document.createElement('span');
      removeText.textContent = 'Verwijderen';
      removeBtn.appendChild(removeText);

      removeBtn.addEventListener('mouseenter', () => {
        removeBtn.style.color = '#c2410c';
      });

      removeBtn.addEventListener('mouseleave', () => {
        removeBtn.style.color = '#6b7280';
      });

      removeBtn.addEventListener('click', () => {
        uploadedFiles.splice(idx, 1);
        updateHiddenField();
        renderStatus();
        setError('');
      });

      line.appendChild(bullet);
      line.appendChild(nameSpan);
      line.appendChild(removeBtn);

      wrapper.appendChild(titleRow);
      wrapper.appendChild(line);
      statusEl.appendChild(wrapper);
    });
  }

  function updateHiddenField() {
    const encoded = uploadedFiles.map((f, idx) => `${idx + 1}:${f.id}|${f.name}`).join('||');
    hiddenIds.value = encoded;

    const prettyLines = uploadedFiles.map((f, idx) => {
      if (uploadedFiles.length === 1) return `Bestand opgeslagen: ${f.name}`;
      return `Bestand ${idx + 1}: ${f.name}`;
    });
    hiddenLabel.value = prettyLines.join('\n');

    try {
      sessionStorage.setItem('ss_uploaded_designs', encoded || '');
    } catch (e) {}
  }

  async function uploadSingleFile(file) {
    const ext = (file.name.split('.').pop() || '').toLowerCase();
    if (!ALLOWED_EXT.includes(ext)) { setError('Dit bestandstype is niet toegestaan.'); return; }
    if (file.size > MAX_SIZE) { setError('Bestand is groter dan 50 MB.'); return; }

    clearError();
    uploadsInFlight++;
    statusEl.textContent = 'Uploaden… even geduld a.u.b.';

    try {
      const fd = new FormData();
      fd.append('file', file);

      const resp = await fetch(UPLOAD_URL, { method: 'POST', body: fd, credentials: 'same-origin' });
      const json = await resp.json().catch(() => null);

      if (!resp.ok) {
        const serverError = json && json.error ? json.error : 'HTTP ' + resp.status;
        throw new Error(serverError);
      }

      if (!json.ok || !json.file_id) throw new Error(json.error || 'Onbekende uploadfout');

      window.SSOffer?.rememberUploadReceipt?.(json);
      uploadedFiles.push({ id: json.file_id, name: json.original_name || file.name });

      updateHiddenField();
      renderStatus();
    } catch (err) {
      const message = err && err.message ? err.message : '';
      if (message === 'Bestandstype niet toegestaan') {
        setError('Dit bestandstype is niet toegestaan.');
      } else if (message === 'Forbidden origin') {
        setError('Uploaden is tijdelijk niet beschikbaar. Probeer het opnieuw.');
      } else {
        setError('Uploaden mislukt. Probeer het opnieuw.');
      }
    } finally {
      uploadsInFlight--;
      if (!uploadsInFlight && uploadedFiles.length) {
        clearError();
        renderStatus();
      }
    }
  }

  async function handleFiles(fileList) {
    if (!fileList || !fileList.length) return;

    const remaining = MAX_FILES - uploadedFiles.length;
    if (remaining <= 0) { setError(`Je kunt maximaal ${MAX_FILES} bestanden uploaden.`); return; }

    const files = Array.from(fileList).slice(0, remaining);
    if (fileList.length > remaining) {
      setError(`Er zijn al ${uploadedFiles.length} bestanden. Max is ${MAX_FILES}. Extra bestanden zijn genegeerd.`);
    }

    for (const f of files) await uploadSingleFile(f);
  }

  fileInput.addEventListener('change', async () => {
    await handleFiles(fileInput.files);
    fileInput.value = '';
  });

  ['dragenter', 'dragover'].forEach(evt => {
    dropZone.addEventListener(evt, (e) => {
      e.preventDefault();
      e.stopPropagation();
      dropZone.classList.add('is-dragover');
    });
  });

  ['dragleave', 'dragend', 'drop'].forEach(evt => {
    dropZone.addEventListener(evt, (e) => {
      e.preventDefault();
      e.stopPropagation();
      dropZone.classList.remove('is-dragover');
    });
  });

  dropZone.addEventListener('drop', async (e) => {
    const dt = e.dataTransfer;
    if (!dt || !dt.files || !dt.files.length) return;
    await handleFiles(dt.files);
  });

  form.addEventListener('submit', (e) => {
    if (uploadsInFlight > 0) {
      e.preventDefault();
      alert('Je bestanden zijn nog aan het uploaden. Wacht even tot dit klaar is.');
    }
  });
});